<div id="contents" role="main" style="min-height: 395px;">
	<section class="flex_ctr_bx">
		<div class="check-container">
			<div class="check-left">
				<h2>Check Your Eligibility</h2>
				<h3>for <strong>Samsung Care+</strong></h3>
				<p>Samsung Care+ is now available for eligible TVs and major Home Appliance products.</p>
				<p class="nomargin">Eligibility period for Care+ is within 14 months from the date of manufacture.
					For any further inquiries on Care+, please contact us at 866-371-9501
					</p>
					<div class="check-icon"><img src="./assets/images/arrow-right.png" width=30px ></div>
			</div>
			<div class="check-right">
				<div class="check-input-wrapper">
					<div [formGroup]="form" class="form_wrap type2">
						<div class="radio-tab imei on" data-ng-if="vm.deviceType == '00'">
							<div class="form_group data_type">
								<div class="tit">
									<label for="modelCode">
										Model Code <i class="ico_compulsory">*</i>
									</label>
								</div>
								<div class="txt right_gap">
									<span class="inp_wrap">
										<input type="text"
                           [value]="form.value.modelCode"
                           id="modelCode"
                           formControlName="modelCode"
                           placeholder="Enter your Model Code (ex. QK12A90HAFAQZ)"
                           limit-char=""
                           limit="15"
                           minlength="15">
										<span class="focus-border"><i></i></span>
									</span>
									<span *ngIf="form.controls.modelCode.dirty && form.controls.modelCode.hasError('required')" class="warning">
										Please enter a model code.
									</span>
								</div>
							</div>
						</div>
						<div class="form_group data_type">
							<div class="tit">
								<label for="serialNumber">Serial Number <i class="ico_compulsory">*</i>
								</label>
							</div>
							<div class="txt right_gap">
								<span class="inp_wrap">
									<input (keypress)="keyPressAlphaNumericOnly($event)"
                         pattern="[a-zA-Z0-9]*"
                         [value]="form.value.serialNumber"
                         id="serialNumber"
                         formControlName="serialNumber"
                         type="text"
                         placeholder="Enter your Serial Number (ex.10NH1AKA912820K)"
                         limit-char=""
                         limit="15"
                         minlength="15"
                         maxlength="15">
									<span class="focus-border"><i></i></span>
								</span>
								<span *ngIf="form.controls.serialNumber.dirty && form.controls.serialNumber.hasError('required')" class="warning">
									Please enter a serial number.
								</span>
								<span *ngIf="form.controls.serialNumber.dirty && form.controls.serialNumber.hasError('pattern')" class="warning">
									Serial number must contain numbers and alphabets only
								</span>
							</div>
						</div>
            <div class="form_group data_type">
              <div class="tit">
                <label for="ticketNo">Ticket Number <i class="ico_compulsory" (click)="showTicketInfo()">?</i>
                </label>
              </div>
              <div class="txt right_gap">
								<span class="inp_wrap">
									<input [value]="form.value.ticketNo"
                         id="ticketNo"
                         formControlName="ticketNo"
                         type="text"
                         placeholder="Enter the Ticket Number you've got from technician"
                         minlength="10"
                         maxlength="10">
									<span class="focus-border"><i></i></span>
								</span>
                <span *ngIf="form.controls.serialNumber.dirty && form.controls.ticketNo.hasError('pattern')" class="warning">
									Ticket number must contain 10 digits numbers only
								</span>
              </div>
            </div>
						<div class="form_group data_type">
						<div class="find-text-left">
								&nbsp;
							<!-- <a href="https://www.samsung.com/us/support/#find-codes">How can I find Model Code and Serial Number?</a> -->
					</div>
					<div class="find-text">
						<!-- <a href="http://stgwebus.samsung.com/us/support/#find-codes">How can I find Model Code and Serial Number?</a>  -->
						<!-- <a href="https://www.samsung.com/us/support/#find-codes">How can I find Model Code and Serial Number?</a> -->
						<a target="_blank" href="https://www.samsung.com/us/support/#find-codes">How can I find Model Code and Serial Number?</a>

				</div></div>

						<!-- <div class="btn_area only">
							<a class="btn btn_type1"
								[ngClass]="{'disable': !(form.value.modelCode && form.value.serialNumber && isRecaptchaSuccess)}"
								(click)="onCheck()">Check</a>
						</div> -->

						<div class="captcha_area">
							<div *ngIf="!isRecaptcharRestart">
								<ngx-recaptcha2 class="recaptcha2" [siteKey]="siteKey" (success)="onRecatcharSuccess($event)" (expire)="onRecaptchaExpired()"
									formControlName="recaptcha">
								</ngx-recaptcha2>
							</div>

						</div>
					</div>

				</div>

			</div>
		</div>
		<div class="btn_area only">
			<a class="btn btn_type1" [ngClass]="{'disable': !(form.value.modelCode && form.value.serialNumber && isRecaptchaSuccess)}"
				(click)="onNext()">Continue to select product <img src="./assets/images/button-arrow.png"></a>
<!--      <a class="btn btn_type1" [ngClass]="{'disable': !(form.value.modelCode && form.value.serialNumber)}"-->
<!--         (click)="onNext()">Continue to select product <img src="./assets/images/button-arrow.png"></a>-->
		</div>
	</section>
</div>
